import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "components/atoms";
import { StudyPalnFilter } from "components/molecules/StudyPlanFilter";
import { BackButton } from "components/molecules";
import dayjs from "dayjs";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const AddToStudyPlan = ({ theme }: IProps) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <div className="add-to-study-plan-wrapper">
      <BackButton theme={theme} fallbackPath="/study-planner" />
      <div className="add-to-study-plan-text-section">
        <Typography label="Add To Study Plan" variant="h6Bold" />
      </div>
      {state.date ? <StudyPalnFilter theme={theme} date={state.date} /> : null}
    </div>
  );
};
